export const SIGN_UP = 'SIGN UP';
export const LOGIN = 'LOGIN';

export const WELCOME_BACK = 'Welcome Back';
export const WELCOME = 'Welcome';
export const SIGN_IN = 'Sign In';
export const LOG_IN = 'Log In';
export const SIGN_UP_CAPITAL_FIRST_LETTER = 'Sign Up';

export const EMPOWER_YOUR_FINANCIAL_DECISIONS = 'Empower Your Financial Decisions';

export const SIGN_IN_WITH_GOOGLE = 'Sign In with Google';
export const SIGN_IN_WITH_FACEBOOK = 'Sign In with Facebook';
export const SIGN_UP_WITH_GOOGLE = 'Sign Up with Google';
export const SIGN_UP_WITH_FACEBOOK = 'Sign Up with Facebook';

// First Name
const firstName = 'firstName';
export const firstNameLabel = 'First Name';
const firstNameRequired = 'Please Enter Your First Name';

// Last Name
const lastName = 'lastName';
export const lastNameLabel = 'Last Name';
const lastNameRequired = 'Please Enter Your Last Name';

// Email
export const email = 'email';
export const emailLabel = 'Email';
export const emailRequired = 'Please Enter Your Email';
export const emailValidRequired = 'Please Enter a Valid Email';

export const Email = 'Email';

export const enterEmail = 'Enter Your Email';

export const phoneNumber = 'phone number';
export const phoneNumberLabel = 'Phone Number';

export const dateOfBirthLabel = 'Date of Birth';

export const addressLabel = 'Address';

// Phone

// Password
export const password = 'password';
export const passwordLabel = 'Password';
export const passwordRequired = 'Please Enter Your Password';

// Confirm Password
// const confirmPassword = 'confirmPassword';
// const confirmPasswordLabel = 'Re-enter Password';
// const confirmPasswordRequired = 'Please Confirm Your Password';

export const passwordNeedMatch = 'Passwords need to match';

export const emailPattern = {
  value:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  message: emailValidRequired,
};

export const SIGN_UP_TRACKING_NAME = {
  [firstName]: firstName,
  [lastName]: lastName,
  [email]: email,
};

export const SIGN_UP_FORM_ROWS = {
  NAME: [
    {
      id: firstName,
      name: firstName,
      className: firstName,
      label: firstNameLabel,
      required: firstNameRequired,
    },
    {
      id: lastName,
      name: lastName,
      className: lastName,
      label: lastNameLabel,
      required: lastNameRequired,
    },
  ],
  CONTACT: [
    {
      id: email,
      name: email,
      className: email,
      label: emailLabel,
      required: emailRequired,
      pattern: emailPattern,
    },
  ],
  PASSWORD: [
    {
      id: password,
      name: password,
      className: password,
      type: password,
      label: passwordLabel,
      required: passwordRequired,
    },
  ],
  // CONFIRM_PASSWORD: [
  //   {
  //     id: confirmPassword,
  //     name: confirmPassword,
  //     className: confirmPassword,
  //     type: password,
  //     label: confirmPasswordLabel,
  //     required: confirmPasswordRequired,
  //   },
  // ],
};

export const Forgot_Password = 'Forgot Password?';
export const ALREADY_HAVE_ACCOUNT = 'Already have an account?';
export const LOGIN_LINK_TEXT = 'Login';

export const FORGOT_PASSWORD_HEADER = 'Forgot Password?';
export const FORGOT_PASSWORD_PARAGRAPH_TEXT = 'We will send you a Password Reset Link.';
export const PASSWORD_RESET_LINK_SENT = 'Password Reset Link has been sent.';
export const SEND = 'Send';
export const UPDATE_EMAIL = 'UPDATE EMAIL';

export const FORGOT_PASSWORD_VERIFICATION_TEXT =
  'We have sent a verification code to the email you entered';

export const REMEMBER_PASSWORD = 'Remember Password? ';
export const verificationCode = 'Verification Code';
export const verificationRequired = 'Verification code is required.';
export const enterVerification = 'Enter Verification Code';
export const codeNotReceived = "Didn't receive the code? ";
export const resend = 'Resend';
export const save = 'Save';
export const verificationCodeSentTo =
  'If the email you provided is associated with an account, we have sent a verification code to: ';

export const resetPassword = 'Reset Password';
export const newPassword = 'Enter New Password';
export const reenterPassword = 'Re-enter Password';
export const updatePassword = 'Update Password';
export const signupPrompt = "Don't have an accout? ";

export const SELECTED_LOG_IN_SIGN_UP_FORM = {
  '&:hover': { backgroundColor: 'black', color: 'white' },
  m: 0,
  color: 'white',
  textTransform: 'initial',
  backgroundColor: 'black',
  width: '50%',
  borderRadius: 2,
  height: '48px',
  marginBottom: '20px',
};

export const NOT_SELECTED_LOG_IN_SIGN_UP_FORM = {
  '&:hover': { backgroundColor: 'rgb(240, 240, 240);', color: 'black' },
  m: 0,
  color: 'black',
  textTransform: 'initial',
  backgroundColor: 'rgb(240, 240, 240)',
  width: '50%',
  borderRadius: 2,
  height: '48px',
  marginBottom: 2,
};
